import { Organization } from "chq";
import loadOrganizationFonts from "./loadOrganizationFonts";

const loadLatestFontsInJson = (
  mediaData: Record<string, any>,
  organization: Organization
): Record<string, any> => {
  const fonts = Array.from(
    new Map(
      [...mediaData.fonts || [], ...loadOrganizationFonts(organization)].map(font => [`${font.family}-${font.source}`, font])
    ).values()
  );
  return {
    ...mediaData,
    fonts
  };
};

export default loadLatestFontsInJson;
